import { render, staticRenderFns } from "./SampleLayout.vue?vue&type=template&id=24d93c5f"
import script from "./SampleLayout.vue?vue&type=script&lang=js"
export * from "./SampleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports